<div class="complete-profile" *ngIf="content">
  <form class="complete-profile__form" [formGroup]="completeProfileForm" (ngSubmit)="submit()">
    <h2 class="complete-profile__heading">{{ content.fields.completeProfileHeading }}</h2>
    <div class="complete-profile__name-input-container">
      <div class="complete-profile__input-container">
        <input class="complete-profile__input" type="text" name="firstName" formControlName="firstName" />
        <label class="complete-profile__label" for="firstName">{{ content.fields.firstNameLabel }}</label>
        <span class="complete-profile__input-error" *ngIf="hasError(firstName, 'required')">
          {{ globalContent.fields.inputValidationRequired }}
        </span>
      </div>

      <div class="complete-profile__input-container">
        <input class="complete-profile__input" type="text" name="lastName" formControlName="lastName" />
        <label class="complete-profile__label" for="lastName">{{ content.fields.lastNameLabel }}</label>
        <span class="complete-profile__input-error" *ngIf="hasError(lastName, 'required')">
          {{ globalContent.fields.inputValidationRequired }}
        </span>
      </div>
    </div>
    <div class="complete-profile__input-container">
      <input class="complete-profile__input--checkbox" type="checkbox" id="newsletter" formControlName="newsletter" />
      <label class="complete-profile__label--checkbox" for="newsletter">
        {{ content.fields.newsletterCheckbox }}
      </label>
    </div>
    <button class="complete-profile__submit" type="submit">{{ content.fields.completeProfileButtonText }}</button>
  </form>
</div>
